export default "__VITE_ASSET__BEMg3nyN__"